import { useState, useEffect } from 'react';

/**
 * Hook to detect online/offline status
 * Returns current online status and provides event listeners
 */
export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);
      timeoutId = setTimeout(() => setWasOffline(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearTimeout(timeoutId);
    };
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
    wasOffline, // True briefly after reconnecting
  };
};

export default useOnlineStatus;
